import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";

type ProfileFieldLabelProps = {
    children: string;
    isReadOnly: boolean;
};

export function ProfileFieldLabel({
    children,
    isReadOnly = false,
}: ProfileFieldLabelProps) {
    return (
        <Text
            variant="caption"
            className={cn(
                "mb-1 text-primary",
                isReadOnly && "text-muted-foreground",
            )}
        >
            {children}
        </Text>
    );
}
